var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136.23 96.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23026"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23025"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15793",
    d: "m93.61,53.82l35.94,35.95-.9.81c-4.24,3.86-9.76,5.99-15.49,5.99H23.08c-5.73,0-11.25-2.13-15.49-5.99l-.9-.81,35.94-35.95c1.38-1.38,2.87-2.64,4.45-3.78l.8-.57.69.69c10.81,10.75,28.28,10.75,39.09,0l.69-.69.8.57c1.59,1.14,3.08,2.4,4.46,3.78h0Zm37.47-45.27l-.81-.99-38.6,38.58,1.05.8c1.46,1.11,2.84,2.31,4.14,3.61l35.62,35.62.75-1.32c1.97-3.46,3-7.38,3-11.36V23.08c0-5.29-1.83-10.42-5.16-14.53h.01ZM43.51,46.95l1.05-.8L5.97,7.56l-.81,1C1.83,12.67,0,17.79,0,23.08v50.42c0,3.98,1.03,7.9,3,11.36l.75,1.32,35.62-35.62c1.3-1.29,2.68-2.5,4.14-3.61h0Zm24.61,6.67c6.12.02,11.98-2.41,16.3-6.74L126.84,4.46l-1.2-.78C121.92,1.28,117.59,0,113.16,0H23.08c-4.43,0-8.76,1.28-12.48,3.68l-1.2.78,42.42,42.42c4.31,4.34,10.18,6.76,16.3,6.74h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/Messages.41430f9267c7cbf9d1013b380c2e636f.svg";
export { ForwardRef as ReactComponent };